import { parseHtmlToDomNodes } from '~/utils/parseHtmlToDomNodes'
import { mapDomNodesToVNodes } from '~/utils/mapDomNodesToVNodes'

export async function convertHtmlStringToVNodes(
  htmlString: string,
  replacements: Record<
    string,
    (el: HTMLElement, index: Number) => VNode | undefined
  > = {}
): Promise<VNode[]> {
  const domNodes = await parseHtmlToDomNodes(htmlString)
  const vNodes = mapDomNodesToVNodes(domNodes, replacements, ref(0))

  return vNodes
}
